import { forwardRef, useContext } from 'react'

import { Box } from '@mantine/core'

import { CtaBannerItem } from 'interfaces/types'

import { CtaBannerContext } from '../../context'
import { MultipleBanner } from '../../index.types'
import { CarouselLayout } from '../CarouselLayout'
import { GridLayout } from '../GridLayout'

type Props = {
  banners: CtaBannerItem[]
  keepGridCol?: boolean
}

// forwardRef để truyền ref xuống CarouselLayout
export const ListingItem = forwardRef<any, Props>(
  ({ banners, keepGridCol }, ref) => {
    const { data } = useContext(CtaBannerContext)
    const { applyCarousel } = (data || {}) as MultipleBanner

    return (
      <Box>
        {applyCarousel ? (
          <CarouselLayout
            ref={ref}
            banners={banners}
            keepGridCol={keepGridCol}
          />
        ) : (
          <GridLayout banners={banners} keepGridCol={keepGridCol} />
        )}
      </Box>
    )
  },
)

ListingItem.displayName = 'ListingItem'
